import React from "react";
import { motion } from "framer-motion";

function Banner({ image, title, description, buttons = [] }) {
    // Function to check if the URL is a video
    const isVideo = (url) => {
        if (!url) return false;
        const videoExtensions = ['.mp4', '.webm', '.ogg', '.mov'];
        const lowerUrl = url.toLowerCase();
        return videoExtensions.some(ext => lowerUrl.includes(ext));
    };

    const isVideoUrl = isVideo(image);

    return (
        <div className="banner">
            {isVideoUrl ? (
                <>
                    <video 
                        src={image} 
                        autoPlay 
                        loop 
                        muted 
                        playsInline
                        alt={title}
                    />
                    <div className="video-overlay"></div>
                </>
            ) : (
                <img src={image} alt={title} />
            )}
            <div className="banner-content">
                <h1>{title}</h1>
                <p>{description}</p>
                {buttons.length > 0 && (
                    <motion.div
                        initial={{ opacity: 0, y: 20 }}
                        animate={{ opacity: 1, y: 0 }}
                        transition={{ duration: 1 }}
                        className="category-buttons"
                    >
                        {buttons.map((btn, idx) => (
                            <button
                                key={idx}
                                onClick={() =>
                                    (window.location.href = btn.link)
                                }
                            >
                                {btn.text}
                            </button>
                        ))}
                    </motion.div>
                )}
            </div>
        </div>
    );
}

export default Banner;